import React from 'react';
import type { DSLeftNavigationT } from '../react-desc-prop-types.js';

interface SmoothExpandOptsT {
  expandedForAnimation: boolean;
  timeoutRef: React.MutableRefObject<NodeJS.Timeout | null>;
  setExpandedForAnimation: React.Dispatch<React.SetStateAction<boolean>>;
}
export const useLeftNavSmoothExpand = (props: DSLeftNavigationT.Props, smoothExpandOpts: SmoothExpandOptsT): void => {
  const { expanded } = props;
  const { expandedForAnimation, timeoutRef, setExpandedForAnimation } = smoothExpandOpts;

  React.useEffect(() => {
    // If expanded changes, we need to smoothly transition to the non-expanded state
    // so we need to wait for 350ms
    if (!expanded && expandedForAnimation) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setExpandedForAnimation(false), 350);
    } else if (expanded) setExpandedForAnimation(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded]);

  React.useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    [timeoutRef],
  );
};

export default useLeftNavSmoothExpand;
